import { variantFilterLoops, rebuildPVDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const updateVariantFilterLoops = ({
    readOnly,
    checked,
    indeterminate,
}) => {
    variantFilterLoops(readOnly, checked, indeterminate);
    if (apiProvider.getActiveAction() ==='process_miner') rebuildPVDiagram('variantFilterLoops');
};
